import React from 'react';
import Box from '@mui/material/Box';
import { RankingItem, ThemeTone } from '../../../core/types/common.types';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
import { clampPercentage, formatPercentage } from '../../../core/utils/common/formatters';

interface RankingListProps {
  items: RankingItem[];
  tone: ThemeTone;
}

function RankingList({ items, tone }: RankingListProps) {
  return (
    <Box>
      {items.map((item) => (
        <Box key={item.label} sx={{ mb: 1.5 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, mb: 0.5 }}>
            <Typography variant="body2" sx={{ fontWeight: 700 }}>
              {item.label}
            </Typography>

            <Typography variant="body2" color={`${tone}.dark`} sx={{ fontWeight: 900 }}>
              {formatPercentage(item.value)}
            </Typography>
          </Box>

          <LinearProgress
            variant="determinate"
            value={clampPercentage(item.value)}
            color={tone}
            sx={{
              height: 9,
              borderRadius: 999,
              bgcolor: `${tone}.lighter`,
              '& .MuiLinearProgress-bar': {
                borderRadius: 999,
              },
            }}
          />
        </Box>
      ))}
    </Box>
  );
}

export default RankingList;
